import { render } from "./px-badge.vue?vue&type=template&id=72933330&ts=true"
import script from "./px-badge.vue?vue&type=script&lang=ts"
export * from "./px-badge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__